// extracted by mini-css-extract-plugin
export var animationContainer = "_gp-0";
export var footer = "_gp-1";
export var gray = "_gp-2";
export var lineItem = "_gp-3";
export var lineItemImage = "_gp-4";
export var lineItemInfo = "_gp-5";
export var lineItemText = "_gp-6";
export var lineItems = "_gp-7";
export var modalContent = "_gp-8";
export var options = "_gp-9";
export var orderName = "_gp-a";
export var refundAmount = "_gp-b";